import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import HeaderMain from "./Components/HeaderMain.jsx";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import styles from "./NewsDetails.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faEye,
  faQuoteLeft,
  faQuoteRight,
} from "@fortawesome/free-solid-svg-icons";
import TextAds from "../components/textAd.jsx";
import ImageVideoAds from "../components/imageVideoAd.jsx";
import ImageModal from "../common/FullScreenImageModal.jsx";

const NewsDetails = ({ preview, selectTheSlot }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [carouselSlide, setCarouselSlide] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImageIndex, setModalImageIndex] = useState(0);
  const [adsSelected, setAdsSelected] = useState([]);
  const [currentAdIndexes, setCurrentAdIndexes] = useState({
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
  });
  const [selectedAd, setSelectedAd] = useState(null);
  const [ads, setAds] = useState([]);
  const [newsItem, setNewsItem] = useState({
    title: "Fast Arena Hosts National Football Championship 2025",
    created_at: "2025-07-17T15:52:38.000Z",
    clicks: 1234,
    sport_name: "Football",
    content: `### Championship Highlights

Fast Arena was packed with energy and talent this weekend as it hosted the National Football Championship 2025. Teams from across the country competed in an electrifying series of matches.

**Key Moments:**
- Last-minute goal by the defending champs.
- Surprise semi-finalist from a newly formed club.
- Record attendance of 15,000+ fans!

Stay tuned for post-event interviews and player stats.`,
    references: [
      "https://www.sportsnews.com/fast-arena-championship-2025",
      "https://www.federationfootball.org/events/2025",
    ],
  });

  useEffect(() => {
    const fetchNewsDetails = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin-news/news/${id}`,
          { withCredentials: true }
        );
        setNewsItem(response.data);
      } catch (err) {
        console.error("Error fetching news details:", err);
        setError("Failed to load news details");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchNewsDetails();
    }
  }, [id]);

  const handleSlideChange = (index) => {
    setCarouselSlide(index);
  };

  const getMediaItems = (newsItem) => {
    const media = [];
    if (newsItem.images && newsItem.images.length > 0) {
      media.push(
        ...newsItem.images.map((img) => ({
          type: "image",
          src: `${img}`,
        }))
      );
    }
    if (newsItem.video_path) {
      media.push({
        type: "video",
        src: `${process.env.REACT_APP_BASE_URL}${newsItem.video_path}`,
      });
    }
    return media;
  };

  const handleImageClick = (index) => {
    setModalImageIndex(index);
    setIsModalOpen(true);
  };

  const getImageOnlyItems = () => {
    return mediaItems
      .filter((item) => item.type === "image")
      .map((item) => item.src);
  };

  useEffect(() => {
    if (preview) return;

    let isMounted = true;
    let timeoutId;

    const fetchAds = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/download-ad`
        );
        if (isMounted) setAds(response.data.ads);
      } catch (error) {
        console.error("Error fetching ads:", error);
      }

      if (isMounted) {
        timeoutId = setTimeout(fetchAds, 500);
      }
    };

    fetchAds();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [preview]);

  const handleClicks = async (e, ad) => {
    if (preview) {
      const id = e.currentTarget.dataset.id;

      if (
        (id === "ad-1" && preview === "text") ||
        ((id === "ad-2" || id === "ad-3") && preview === "image") ||
        ((id === "ad-4" || id === "ad-5") && preview === "video")
      ) {
        setSelectedAd(id);
        selectTheSlot(id);
      }
    }

    e.preventDefault();

    if (!ad || !ad.url) return;
    window.location.href = ad.url;
    ad.clicks = ad.clicks + 1;

    try {
      const jsonData = {
        clicks: ad.clicks,
        id: ad.ids,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/upload-clicks`,
        jsonData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
      } else {
        throw new Error(response.data.message || "Failed to upload clicks");
      }
    } catch (error) {
      console.error("Error uploading clicks:", error);
      alert("Failed to upload Clicks: " + error.message);
    }
  };

  const convertDate = (dateString) => {
    const dateObj = new Date(dateString);

    dateObj.setDate(dateObj.getDate());

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  useEffect(() => {
    const getCurrentAds = () => {
      const now = new Date();
      const isoDate = now.toISOString().slice(0, 10); // "2025-06-17"
      const current_date = `${isoDate}T00:00:00`;
      const current_time = now.toTimeString().split(" ")[0];

      const newAds = [];

      for (const ad of ads) {
        const isDateInRange =
          ad.start_date.split("T")[0] <= current_date.split("T")[0] &&
          convertDate(current_date) <= ad.end_date.split("T")[0];

        const datePart = convertDate(current_date);
        const currentTime = new Date(`${datePart}T${current_time}`);
        const startTime = new Date(`${datePart}T${ad.start_time}`);
        const endTime = new Date(`${datePart}T${ad.end_time}`);
        const isTimeInRange =
          startTime <= currentTime && currentTime <= endTime;

        const isTimeIterRemaining = ad.total_time > 0;

        if (
          isDateInRange &&
          isTimeInRange &&
          isTimeIterRemaining &&
          ad.slotPlace.split(" ")[0] === "newsDetailPage"
        ) {
          newAds.push(ad);
        }
      }

      if (JSON.stringify(adsSelected) !== JSON.stringify(newAds)) {
        const indexedAds = [];

        newAds.forEach((ad) => {
          const slotPlace = ad.slotPlace;
          const index = parseInt(slotPlace.trim().split(" ").pop(), 10);

          if (!isNaN(index)) {
            if (!indexedAds[index]) {
              indexedAds[index] = [];
            }
            indexedAds[index].push(ad);
          }
        });

        setAdsSelected(indexedAds);
      }
    };

    getCurrentAds();

    const interval = setInterval(() => {
      getCurrentAds();
    }, 1000);

    return () => clearInterval(interval);
  }, [ads]);

  const updateIterations = async (slot, i) => {
    if (!adsSelected[slot] || !adsSelected[slot][i]) return;

    try {
      const jsonData = {
        iterations: adsSelected[slot][i].iterations,
        total_time: adsSelected[slot][i].total_time,
        id: adsSelected[slot][i].ids,
        intervals: adsSelected[slot][i].intervals,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/upload-iterations`,
        jsonData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
      } else {
        throw new Error(response.data.message || "Failed to upload iterations");
      }
    } catch (error) {
      console.error("Error uploading iterations:", error);
      alert("Failed to upload Iterations: " + error.message);
    }
  };

  useEffect(() => {
    const timers = {};

    Object.keys(adsSelected).forEach((slotKey) => {
      const slot = parseInt(slotKey, 10);
      const adsInSlot = adsSelected[slot];
      const currentIndex = currentAdIndexes[slot];

      if (!adsInSlot || adsInSlot.length === 0 || currentIndex < 0) return;

      let nextIndex = currentIndex;

      const updateSlot = () => {
        // Update iterations if current ad is valid
        if (
          currentIndex < adsInSlot.length &&
          adsInSlot[currentIndex]?.iterations > 0
        ) {
          updateIterations(slot, currentIndex);
        }

        // Find next valid index with iterations > 0
        nextIndex = (currentIndex + 1) % adsInSlot.length;

        if (adsInSlot[nextIndex]?.iterations <= 0) {
          const originalIndex = nextIndex;
          while (
            adsInSlot[nextIndex]?.iterations <= 0 &&
            nextIndex !== currentIndex
          ) {
            nextIndex = (nextIndex + 1) % adsInSlot.length;
            if (nextIndex === originalIndex) break;
          }
        }

        // Prevent infinite loop if no valid ad is found
        if (adsInSlot[nextIndex]?.iterations <= 0) return;

        // Update index state
        setCurrentAdIndexes((prev) => ({
          ...prev,
          [slot]: nextIndex,
        }));
      };

      const interval =
        adsInSlot[currentIndex]?.iterations > 0
          ? adsInSlot[currentIndex]?.intervals
          : 1000;

      timers[slot] = setTimeout(updateSlot, interval);
    });

    return () => {
      // Clear all timers on cleanup
      Object.values(timers).forEach(clearTimeout);
    };
  }, [
    JSON.stringify(currentAdIndexes),
    JSON.stringify(
      Object.fromEntries(
        Object.entries(adsSelected).map(([slot, ads]) => [
          slot,
          ads.map((ad) => ad.iterations).join(","),
        ])
      )
    ),
  ]);

  if (loading && !newsItem) {
    return (
      <div className={styles["news-details-container"]}>
        <HeaderMain pageType="news" />
        <div className={styles.loading}>Loading news details...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles["news-details-container"]}>
        <HeaderMain pageType="news" />
        <div className={styles.error}>{error}</div>
        {/* <button onClick={() => navigate("/")} className={styles["back-btn"]}>
          <FontAwesomeIcon icon={faArrowLeft} /> Back to Home
        </button> */}
      </div>
    );
  }

  if (!newsItem) {
    return (
      <div className={styles["news-details-container"]}>
        <HeaderMain pageType="news" />
        <div className={styles["not-found"]}>News not found</div>
        {/* <button onClick={() => navigate("/")} className={styles["back-btn"]}>
          <FontAwesomeIcon icon={faArrowLeft} /> Back to Home
        </button> */}
      </div>
    );
  }

  const mediaItems = getMediaItems(newsItem);

  return (
    <div className={styles["news-details-container"]}>
      <HeaderMain pageType="news" />
      <div className={styles["ads-container"]}>
        {/* Text Ad Section */}
        <TextAds
          adsSelected={adsSelected}
          currentAdIndexes={currentAdIndexes}
          selectedAd={selectedAd}
          handleClicks={handleClicks}
          preview={preview}
          slot={1}
        />

        <div className={styles["main-container"]}>
          <ImageVideoAds
            adsSelected={adsSelected}
            currentAdIndexes={currentAdIndexes}
            preview={preview}
            handleClicks={handleClicks}
            selectedAd={selectedAd}
            slot1={2}
            slot2={4}
          />

          <div className={styles["news-details-content"]}>
            <article className={styles["news-article"]}>
              <header className={styles["news-header"]}>
                <h1 className={styles["news-title"]}>{newsItem.title}</h1>

                <div className={styles["news-meta"]}>
                  <div>
                    <span className={styles["news-date"]}>
                      {new Date(newsItem.created_at).toLocaleDateString(
                        "en-GB",
                        {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }
                      )}
                    </span>
                    |
                    <span className={styles["news-clicks"]}>
                      <FontAwesomeIcon icon={faEye} /> {newsItem.clicks || 0}
                    </span>
                  </div>
                  {newsItem.sport_name && (
                    <span className={styles["news-sport"]}>
                      {newsItem.sport_name}
                    </span>
                  )}
                </div>
              </header>

              {mediaItems.length > 0 && (
                <div className={styles["news-carousel"]}>
                  <Carousel
                    showThumbs={false}
                    autoPlay={false}
                    showIndicators={false}
                    infiniteLoop={true}
                    interval={5000}
                    stopOnHover={true}
                    showStatus={false}
                    showArrows={false}
                    selectedItem={carouselSlide}
                    onChange={handleSlideChange}
                  >
                    {mediaItems.map((media, index) => (
                      <div key={index} className={styles["media-container"]}>
                        {media.type === "image" ? (
                          <img
                            src={media.src}
                            alt={`${newsItem.title} ${index + 1}`}
                            className={styles["news-media"]}
                            onClick={() => handleImageClick(index)}
                            style={{ cursor: "pointer" }}
                          />
                        ) : (
                          <video
                            src={media.src}
                            className={styles["news-video"]}
                            onClick={(e) => e.stopPropagation()}
                            autoPlay
                            muted
                            loop
                            playsInline
                          />
                        )}
                      </div>
                    ))}
                  </Carousel>
                  <div className={styles["custom-control-dots"]}>
                    {mediaItems.map((_, index) => (
                      <span
                        key={index}
                        className={`${styles["custom-dot"]} ${
                          carouselSlide === index ? styles.active : ""
                        }`}
                        onClick={() => handleSlideChange(index)}
                      />
                    ))}
                  </div>
                </div>
              )}

              <div className={styles["news-content"]}>
                <ReactMarkdown>{newsItem.content}</ReactMarkdown>
              </div>

              {newsItem.references && newsItem.references.length > 0 && (
                <div className={styles["news-references"]}>
                  <h3>References</h3>
                  <ul>
                    {newsItem.references.map((reference, index) => (
                      <li key={index}>
                        <a
                          href={reference}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles["reference-link"]}
                        >
                          {reference}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </article>
          </div>
          <ImageVideoAds
            adsSelected={adsSelected}
            currentAdIndexes={currentAdIndexes}
            preview={preview}
            handleClicks={handleClicks}
            selectedAd={selectedAd}
            slot1={3}
            slot2={5}
          />
        </div>
      </div>

      <ImageModal
        images={getImageOnlyItems()}
        initialIndex={modalImageIndex}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
        alt={newsItem.title}
        isBase64={false}
      />
    </div>
  );
};

export default NewsDetails;
